import React, { useState } from 'react';

const Step1SelectPatient = ({ patients, selectedPatient, setSelectedPatient, goToStep }) => {
    const [input, setInput] = useState('');

    const filteredPatients = patients.filter((p) =>
        p.fullName?.toLowerCase().includes(input.toLowerCase())
    );

    return (
        <div className="step active">
            <div className="section">
                <h2 className="section-title">
                    <span className="number">1</span> Seleccionar paciente
                </h2>

                <div className="search-container">
                    <span className="search-icon">🔍</span>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Buscar paciente..."
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                    />
                </div>

                {filteredPatients.map((patient) => (
                    <div
                        key={patient._id}
                        className={`patient-item ${selectedPatient?._id === patient._id ? 'selected' : ''}`}
                        onClick={() => setSelectedPatient(patient)}
                    >
                        <div className="patient-name">{patient.name} {patient.surname}</div>
                        <div className="patient-details">{patient.email}</div>
                    </div>
                ))}
            </div>

            <div className="sticky-footer">
                <div className="progress-indicator">
                    <div className="progress-dot active"></div>
                    <div className="progress-dot"></div>
                    <div className="progress-dot"></div>
                </div>
                <button
                    className="action-button"
                    disabled={!selectedPatient}
                    onClick={() => goToStep(2)}
                >
                    Continuar
                </button>
            </div>
        </div>
    );
};

export default Step1SelectPatient;
